import React, { useState, useEffect, useContext } from 'react';
import facebook from '../../assets/Footer/facebook.svg';
import HereForYou from '../../assets/Footer/Here-For-You.svg';
import instagram from '../../assets/Footer/instagram.svg';
import linkedin from '../../assets/Footer/linkedin.svg';
import twitter from '../../assets/Footer/twitter.svg';
import youtube from '../../assets/Footer/youtube.svg';
import './Footer.css';
import { Link, Navigate } from 'react-router-dom';
import mobileLightHome from '../../assets/mobileBottomHomeLight.svg';
import mobileLightMenu from '../../assets/mobileBottomMenuLight.svg';
import mobileBottomHomeHigh from '../../assets/mobileBottomHomeHigh.svg';
import referAndEarnI from '../../assets/SideNavbar/marketing-flow.svg';

import { useLocation } from 'react-router-dom';
import signOut from '../../assets/sign-out.svg';
import useAuth from '../../services/authContext';
import { useNavigate } from 'react-router-dom';

import closeMenu from '../../assets/closeMenu.svg';
import sideDash from '../../assets/SideNavbar/Dashboard.svg';
import userProfileDash from '../../assets/SideNavbar/user.svg';
import DematIconDash from '../../assets/SideNavbar/DematIcon.svg';
import InVestLogo from '../../assets/SideNavbar/sideNavInvestLogo.svg';
import { Context } from '../../services/apiContext';

const Footer = (props) => {
  const { logout, authed } = useAuth();
  const navigate = useNavigate();
  const [path, setpath] = useState('');
  let location = useLocation(); //to check router path
  const [showRefer, setShowRefer] = useState(true);
  const contextapi = useContext(Context);

  const [pageBool, setpageBool] = useState(false);
  const [onHomepageload, setonHomepageload] = useState(false);
  useEffect(() => {}, []);
  useEffect(() => {
    let cseData = contextapi.getSession('cseData');
    if (cseData) {
      setShowRefer(false);
    }

    validateSession();
    setpath(location.pathname);
  }, [location.pathname]);
  // const [open, setopen] = useState(false)
  const [showNav, setshowNav] = useState(false);
  const toggleNav = (that) => {
    setshowNav(!showNav);

    let div = document.querySelector('.App');
    let divRoot = document.getElementById('root');

    for (let cssClass of div.classList) {
      if (showNav == false) {
        div.classList.add('infoMenuModel');
        // divRoot.classList.add('divRoot')
      } else if (showNav == true) {
        div.classList.remove('infoMenuModel');
        // divRoot.classList.remove('divRoot')
      }
    }

    //  setopen(true)
  };

  const signout = () => {
    logout().then(() => {
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('userData');
      navigate('/signIn');
    });
  };
  const validateSession = () => {
    if (
      location.pathname == '' ||
      location.pathname == '/' ||
      location.pathname == '/signIn'
    ) {
      setpageBool(false);
    } else {
      setpageBool(true);
    }

    if (location.pathname == '/Home/dashboard') {
      setonHomepageload(true);
    } else {
      setonHomepageload(false);
    }
  };

  const closeModal = () => {
    toggleNav();
  };
  return (
    <>
      <div className={`footer ${authed === true ? 'addMarginBottom' : ''}`}>
        <div className='row'>
          <div className='col-md-4 copy'>
            © Copyright KFintech 2022 | All Rights Reserved.
          </div>
          <div className='col-md-8 socialmedia textAlignRight' style={{paddingRight:'50px'}}>
            <ul>
              <li>Follow Us :</li>
              {/* <li><a href="#"><img src={facebook} className="img" /></a></li> */}
              <li>
                <a
                  target='_blank'
                  href='https://www.linkedin.com/in/kfintech2019/'
                >
                  <img src={linkedin} className='img' />
                </a>
              </li>
              <li>
                <a
                  target='_blank'
                  href='https://www.instagram.com/kfintechindia/?hl=en'
                >
                  <img src={instagram} className='img' />
                </a>
              </li>
              <li>
                <a
                  target='_blank'
                  href='https://www.youtube.com/channel/UCgoNI8dZ033EqXZ7IqQ2fVw/featured?view_as=subscriber'
                >
                  <img src={youtube} className='img' />
                </a>
              </li>
              <li>
                <a target='_blank' href='https://twitter.com/KFintech2019'>
                  <img src={twitter} className='img' />
                </a>
              </li>
            </ul>
          </div>
          {/* <div className="col-md-2"><img src={HereForYou} className="img" /></div> */}
        </div>

        <div className='navbarMobileNewRelativeINfooter'>
          <div className='row'>
            <div className='col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-6'>
              <a
                className='nav-link '
                target='_blank'
                href='https://mfs.kfintech.com/mfs/'
              >
                Mutual Funds
              </a>
            </div>
            <div className='col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-6'>
              <a
                className='nav-link'
                target='_blank'
                href='https://ris.kfintech.com/'
              >
                Corporate Registry
              </a>
            </div>

            <div className='col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-6'>
              <a
                className='nav-link'
                target='_blank'
                href=' https://nps.kfintech.com/'
              >
                NPS
              </a>
            </div>

            <div className='col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-6'>
              <a
                className='nav-link '
                target='_blank'
                href='https://ipo.kfintech.com/'
              >
                IPO
              </a>
            </div>

            <div className='col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-6'>
              <a
                className='nav-link '
                target='_blank'
                href='https://www.kfintech.com/private-wealth-management/'
              >
                Private Wealth Management
              </a>
            </div>

            <div className='col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-6'>
              <a
                className='nav-link '
                href='https://www.kfintech.com/alternate-investment-fund/'
              >
                Alternatives
              </a>
            </div>

            {/*
                        <div className="col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-6">
                            <a className="nav-link" href="#">
                                Blog
                            </a>
                        </div>

                        <div className="col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-6">
                            <a className="nav-link " href="">
                                Bonds
                            </a>
                        </div> */}
            <div className='col-lg-2 col-md-2 col-sm-3 col-3 col-xs-3 col-4'>
              <a
                className='nav-link'
                target='_blank'
                href='https://www.kfintech.com/about-us/'
              >
                About Us
              </a>
            </div>
          </div>
        </div>

        <div>
          {authed && (
            <div className='navbarMobile'>
              <Link className='active newcssTempLeft' to={'Home/dashboard'}>
                {/* <a className="active newcssTempLeft"> */}
                {authed && (
                  <>
                    <img
                      src={mobileLightHome}
                      alt='img'
                      className={`mobileLightDefault ${
                        onHomepageload === true ? 'hidelightimf' : ''
                      }`}
                    />
                    <img
                      src={mobileBottomHomeHigh}
                      alt='img'
                      className={`mobileLightonhover ${
                        onHomepageload === true ? 'hidelightimfshowHigh' : ''
                      }`}
                    />
                    <p className='bottomLabel'> Home</p>
                  </>
                )}
                {/* </a> */}
              </Link>

              {/* <a className="hideForNow">
                                    {pageBool && contextapi != "" && (
                                        <>
                                            <img
                                                src={mobileLightSub}
                                                alt="img"
                                                className="mobileLightDefault"
                                            />
                                            <img
                                                src={mobileLightSub}
                                                alt="img"
                                                className="mobileLightonhover"
                                            />
                                            <p className="bottomLabel">Subscriptions</p>
                                        </>
                                    )}
                                </a> */}
              <a onClick={toggleNav} className='newcssTempRight'>
                {!showNav && (
                  <>
                    <img
                      src={mobileLightMenu}
                      alt='img'
                      className={`mobileLightDefault `}
                    />
                    <img
                      src={mobileLightMenu}
                      alt='img'
                      className={`mobileLightonhover `}
                    />
                  </>
                )}

                {showNav && (
                  <img
                    src={closeMenu}
                    alt='img'
                    className='mobileLightonhovernon'
                  />
                )}
                <p className='bottomLabel'> Menu</p>
              </a>

              <div
                className={
                  (showNav ? 'showDropdown' : '') + ' mobilecollapse_new'
                }
              >
                <div className='mbileMenuMain'>
                  {authed && (
                    <div className='MainDashbflex'>
                      <div className='firstMinflx'>
                        <div className='listView' onClick={closeModal}>
                          <Link
                            className='sideNewA sideNewA_initial'
                            to={'Home/dashboard'}
                          >
                            <img
                              src={sideDash}
                              alt='img'
                              className='sideDashHeader'
                            />{' '}
                            Dashboard
                          </Link>
                        </div>
                        <div className='listView' onClick={closeModal}>
                          <Link
                            className='sideNewA sideNewA_initial'
                            to={'userProfile'}
                          >
                            <img
                              src={userProfileDash}
                              alt='img'
                              className='sideDashHeader'
                            />{' '}
                            User Profile
                          </Link>
                        </div>

                        <div className='listView' onClick={closeModal}>
                          <Link
                            className='sideNewA sideNewA_initial'
                            to={'createDemat'}
                          >
                            <img
                              src={DematIconDash}
                              alt='img'
                              className='sideDashHeader'
                            />{' '}
                            Demat
                          </Link>
                        </div>

                        {showRefer && (
                          <div className='listView' onClick={closeModal}>
                            <Link
                              className='sideNewA sideNewA_initial'
                              to={'/Home/referral'}
                            >
                              <img
                                src={referAndEarnI}
                                alt='img'
                                className='sideDashHeader'
                              />{' '}
                              Refer and Earn
                            </Link>
                          </div>
                        )}
                        {/* <div className="listView">
                                                        <Link
                                                            className="sideNewA sideNewA_initial"
                                                            to={"IPO"}
                                                        >
                                                            <img src={subscriptionDash} alt='img' className="sideDashHeader" />  IPO Subscription
                                                        </Link>
                                                    </div>
                                                    <div className="listView">
                                                        <Link
                                                            className="sideNewA sideNewA_initial"
                                                            to={"transactions"}
                                                        >
                                                            <img src={transactionDash} alt='img' className="sideDashHeader" />  Transactions
                                                        </Link>
                                                    </div> */}
                      </div>

                      <div className='secImgdiv'>
                        <div className='headDIvLogoImg'>
                          <div className='onemor'>
                            <div className='logoDiv'>
                              <img
                                src={InVestLogo}
                                alt='Investlogo'
                                className='logoCr'
                              />
                            </div>
                            <div className='LogoInvDivJeader'>
                              <p className='LogoInvestText'>
                                We make it <span>Easy</span> for every one to
                                Invest
                              </p>
                              <button className='btn-more custommore'>
                                More
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Footer;
